import React, {useEffect, useState} from 'react';
import '../Components/ComponentCss/Registration_body2.css';
import axios from "axios";
import config from "../ip.json";
import Swal from "sweetalert2"; // CSS 파일 임포트

const RegistrationBody2 = ({companyList}) => {
    // 상태 변수 선언
    const [selectedCompany, setSelectedCompany] = useState('');
    const [roomNumber, setRoomNumber] = useState('');
    const [deposit, setDeposit] = useState('');
    const [area, setArea] = useState('');
    const [pricePerPyeong, setPricePerPyeong] = useState('');
    const [addDate, setAddDate] = useState('');


    // 각 입력 필드에 대한 onChange 핸들러
    const handleCompanyChange = (e) => setSelectedCompany(e.target.value);
    const handleRoomNumberChange = (e) => setRoomNumber(e.target.value);
    const handleDepositChange = (e) => setDeposit(e.target.value);
    const handleAreaChange = (e) => setArea(e.target.value);
    const handlePricePerPyeongChange = (e) => setPricePerPyeong(e.target.value);
    const[companyName, setCompanyName] = useState([]);


    useEffect(() => {
        let nameArr = []
        for (let i = 0; i < companyList.length; i++) {
            nameArr.push(companyList[i].company);

        }
        console.log(nameArr);
        setCompanyName(nameArr);
    },[])




    const data = () => {
        const currentDate = new Date().toISOString(); // 현재 날짜를 ISO 형식으로 변환
        setAddDate(currentDate);
        return {
            member_company: selectedCompany,
            room_number: roomNumber,
            price_per_area: pricePerPyeong,
            add_date: currentDate,
            area_size: area,
            deposit: deposit
        };
    };

    // 등록 처리 함수
    const handleRegistration = () => {
        const fetchData = async () => {
            try {
                const response = await axios.post(
                    config.url + "/v2/room/add"
                    , // config.url을 대신하여 URL 직접 사용
                    data(), // data 함수 호출하여 데이터 전달
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        withCredentials: true, // 쿠키 필요 시 설정
                    }
                );
                if (response.status === 200) {
                    console.log(response.status);
                    업체등록성공();
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                업체등록실패()
            }
        };

        fetchData(); // 비동기 함수 호출
    };

    const 업체등록성공 = (text) => {

        Swal.fire({
            title: "호실이 등록되었습니다!",
            icon: "success"
        });
    }

    const 업체등록실패 = (text) => {
        Swal.fire({
            title: "호실 등록에 실패했습니다.",
            icon: "error"
        });
    }




    const handleChange = (e) => {
        setSelectedCompany(e.target.value);
    };



    return (
        <div className={'registration-body2'}>
            <div className={'registration-body2-left'}>
                <div className={'registration-text1-1'}>추가할 업체 선택</div>
                <div className="registration-text1-select">
                    <input
                        list="companies"
                        placeholder="업체명을 입력하거나 선택해주세요."
                        className="registration-input"
                        value={selectedCompany}
                        onChange={handleCompanyChange}
                    />


                    <datalist id="companies">
                        {companyName.map((company, index) => (
                            <option key={index} value={company}/>
                        ))}
                    </datalist>



                </div>
            </div>

            <div className={'registration-body2-right'}>
                <div className={'registration-body2-right-1'}>
                    <div className={'left'}>
                        <div className={'input-component'}>
                            <div className={'component-text'}>호실번호</div>
                            <div className={'component-inputbox'}>
                                <input
                                    type="text"
                                    placeholder={'예) 101'}
                                    value={roomNumber}
                                    onChange={handleRoomNumberChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={'right'}>
                        <div className={'input-component'}>
                            <div className={'component-text'}>보증금</div>
                            <div className={'component-inputbox-3'}>
                                <input
                                    type="text"
                                    placeholder={'예) 2,000,000'}
                                    value={deposit}
                                    onChange={handleDepositChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'input-component'}>
                    <div className={'component-text2'}>평수</div>
                    <div className={'component-inputbox-2'}>
                        <input
                            type="text"
                            placeholder={'예) 10'}
                            value={area}
                            onChange={handleAreaChange}
                        />
                    </div>
                </div>
                <div className={'input-component'}>
                    <div className={'component-text2'}>평당 가격</div>
                    <div className={'component-inputbox-2'}>
                        <input
                            type="text"
                            placeholder={'예) 13,000'}
                            value={pricePerPyeong}
                            onChange={handlePricePerPyeongChange}
                        />
                    </div>
                </div>
                <div className={'registration-button2'} onClick={handleRegistration}>추가</div>
            </div>
        </div>
    );
};

export default RegistrationBody2;
